var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseCaseManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "340px",
    height: "190px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 518.82 289.93",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .str1 {stroke:white;stroke-width:8.92;stroke-miterlimit:22.9256}\n    .str2 {stroke:white;stroke-width:6.74;stroke-miterlimit:22.9256}\n    .str0 {stroke:white;stroke-width:3.11;stroke-miterlimit:22.9256}\n    .fil13 {fill:none}\n    .fil5 {fill:#005F87}\n    .fil3 {fill:#354453}\n    .fil0 {fill:#3AA9AE}\n    .fil14 {fill:#60BABD}\n    .fil18 {fill:#CBCCCE}\n    .fil1 {fill:#E9E9E9}\n    .fil9 {fill:#FBE594}\n    .fil2 {fill:#FBFAFB}\n    .fil17 {fill:#FC6D39}\n    .fil16 {fill:#FFB800}\n    .fil4 {fill:white}\n    .fil15 {fill:white}\n    .fil7 {fill:#3A4553;fill-rule:nonzero}\n    .fil11 {fill:#C4337C;fill-rule:nonzero}\n    .fil10 {fill:#EB7809;fill-rule:nonzero}\n    .fil6 {fill:#F9D821;fill-rule:nonzero}\n    .fil12 {fill:#FFB800;fill-rule:nonzero}\n    .fil8 {fill:#FFFDFF;fill-rule:nonzero}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 518.82,
    height: 289.93
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2000311058288"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M153.89 242.1l207.31 0c0.43,0 0.78,0.35 0.78,0.78l0 4.68c0,0.43 -0.35,0.79 -0.78,0.79l-207.31 0c-0.44,0 -0.79,-0.36 -0.79,-0.79l0 -4.68c0,-0.43 0.35,-0.78 0.79,-0.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M260.29 163.02l5.04 -0.36c-0.66,2.79 1.51,1.72 -2.11,2.21 -6,0.8 -1.48,-0.4 -2.93,-1.85zm-56.52 0.54c3.88,-1.9 47.66,-1.84 51.36,0 -1.64,1.42 -1.44,1.51 -5.85,1.69l-44.1 -0.69c-0.19,-0.05 -0.62,-0.12 -0.75,-0.47 -0.12,-0.33 -0.45,-0.34 -0.66,-0.53zm21.23 -8.91c3.86,-2.12 82.82,-2.04 86.13,0 -5.17,3.23 -34.58,1.39 -42.88,1.38l-43.25 -1.38zm-21.4 0c3.22,-2.05 12.83,-1.98 16.04,0 -2.16,1.61 2.91,0.53 -3.52,1.43 -0.51,0.07 -4.43,0.05 -5.17,0.04 -4.71,-0.07 -5.08,0.18 -7.35,-1.47zm32.05 -8.91c3.34,-2.14 10.16,-1.23 14.78,-1.23l12.64 0.1c2.22,0.35 1.58,0.51 2.61,1.13 -3.02,1.71 -26.76,1.97 -30.03,0zm-31.99 0c3.27,-2.24 23.01,-2.1 26.63,0 -1.02,0.52 -0.73,0.7 -2.82,1.05 -4.24,0.7 -21.43,0.35 -23.81,-1.05zm0.2 -8.91c3.62,-3.04 15.18,-1.41 21.12,-1.41 5.78,0 17.11,-1.69 20.9,1.41 -3.18,1.58 -38.92,1.51 -42.02,0zm47.34 0c2.84,-2.49 43.34,-2.67 47.08,-0.21 -3.19,1.53 -43.16,2.22 -47.08,0.21zm-64.15 -16.36l0.12 110.29 140.14 0.07 -0.17 -126.12 -139.91 0.16 -0.18 15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M165.92 151.27l-0.03 10.71c-0.12,17.34 -0.04,34.72 -0.02,52.07 0.03,28.47 -4.4,27.85 23.47,27.84 33.09,-0.01 66.19,-0.02 99.28,0 16.44,0.01 33.34,0.4 49.73,0.08 15.08,-0.3 11.21,-8.66 11.23,-39.81 0,-17.16 0,-34.34 0,-51.5 0,-32.31 3.25,-29.76 -21.65,-30.09l-140.88 -0.1c-8.31,0.25 -15.71,-1.51 -19.6,3.51 -3.42,6.29 -1.55,19.14 -1.53,27.29z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil4",
    x: 186.49,
    y: 86.48,
    width: 143.98,
    height: 144.31,
    rx: 7.11,
    ry: 6.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M193.6 86.48l129.77 0c3.91,0 7.1,3.13 7.1,6.95l0 11.07 -143.98 0 0 -11.07c0,-3.82 3.2,-6.95 7.11,-6.95z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M124.78 221.25c-8.4,-4.46 -11.59,-14.87 -7.13,-23.26 4.45,-8.4 14.87,-11.59 23.26,-7.13 8.39,4.45 11.58,14.87 7.13,23.26 -4.46,8.39 -14.87,11.58 -23.26,7.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M126.82 217.4c-6.26,-3.33 -8.65,-11.1 -5.32,-17.37 3.33,-6.26 11.1,-8.64 17.36,-5.32 6.27,3.33 8.65,11.1 5.32,17.36 -3.32,6.27 -11.09,8.65 -17.36,5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M127.32 216.45c-5.74,-3.05 -7.92,-10.17 -4.87,-15.92 3.04,-5.74 10.17,-7.92 15.91,-4.87 5.74,3.05 7.93,10.17 4.88,15.91 -3.05,5.74 -10.17,7.93 -15.92,4.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M132.22 205.59l0.13 -0.1c0.25,-0.21 0.62,-0.17 0.83,0.08l5.43 6.69c0.2,0.25 0.16,0.62 -0.09,0.83l-0.12 0.1c-0.25,0.2 -0.63,0.16 -0.83,-0.09l-5.43 -6.68c-0.21,-0.26 -0.17,-0.63 0.08,-0.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M131.96 207.71c-0.91,-0.49 -1.26,-1.62 -0.77,-2.54 0.48,-0.91 1.62,-1.26 2.53,-0.77 0.92,0.48 1.26,1.62 0.78,2.53 -0.49,0.92 -1.62,1.26 -2.54,0.78z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil9",
    d: "M266.86 58.7c4.34,0.04 1.59,0.99 3.17,-1.91 -3.13,-0.93 -2.52,-1.64 -3.17,1.91z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M268.48 43.82l-4.59 4.6c0,0 -5.69,-4.08 -5.67,-4.95 0.02,-0.88 4.15,-5.35 5.31,-5.32 1.15,0.04 4.95,5.67 4.95,5.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M287.06 43.82l4.6 4.6c0,0 5.69,-4.08 5.66,-4.95 -0.02,-0.88 -4.15,-5.35 -5.3,-5.32 -1.16,0.04 -4.96,5.67 -4.96,5.67z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "fil7",
    points: "280.07,39.13 275.47,39.13 275.47,35.23 280.07,35.23 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M298.85 59.02c0,11.64 -9.44,21.07 -21.08,21.07 -11.64,0 -21.07,-9.43 -21.07,-21.07 0,-11.64 9.43,-21.08 21.07,-21.08 11.64,0 21.08,9.44 21.08,21.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M293.5 59.02c0,8.69 -7.04,15.73 -15.73,15.73 -8.69,0 -15.73,-7.04 -15.73,-15.73 0,-8.69 7.04,-15.73 15.73,-15.73 8.69,0 15.73,7.04 15.73,15.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M292.19 59.02c0,7.96 -6.45,14.42 -14.42,14.42 -7.96,0 -14.42,-6.46 -14.42,-14.42 0,-7.97 6.46,-14.42 14.42,-14.42 7.97,0 14.42,6.45 14.42,14.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M280.99 36.43l-6.5 0c0,0 -1.14,-2.78 -0.5,-3.02 0.63,-0.24 6.71,-0.34 7.5,0 0.8,0.34 -0.5,3.02 -0.5,3.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M277.68 59.98l-0.29 -0.12c-0.34,-0.15 -0.49,-0.54 -0.35,-0.87l4.16 -9.83c0.14,-0.34 0.53,-0.49 0.87,-0.35l0.29 0.12c0.33,0.14 0.49,0.53 0.35,0.87l-4.16 9.83c-0.15,0.33 -0.54,0.49 -0.87,0.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil7",
    d: "M280.07 59.02c0,1.27 -1.03,2.29 -2.3,2.29 -1.27,0 -2.29,-1.02 -2.29,-2.29 0,-1.27 1.02,-2.3 2.29,-2.3 1.27,0 2.3,1.03 2.3,2.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fil8",
    points: "428.87,173.15 424.26,166.81 427.32,159.61 437.02,158.5 433.96,165.71 438.57,172.04 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil8",
    d: "M418.22 181.85c-6.55,11.98 -21.58,16.39 -33.56,9.84 -11.99,-6.55 -16.4,-21.57 -9.85,-33.56 6.55,-11.99 21.57,-16.39 33.56,-9.85 11.99,6.55 16.4,21.58 9.85,33.57z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M386.23 188.81c-10.37,-5.67 -14.2,-18.73 -8.53,-29.1 5.67,-10.38 18.72,-14.21 29.09,-8.54 10.38,5.67 14.21,18.72 8.54,29.1 -5.67,10.38 -18.72,14.21 -29.1,8.54zm17.68 -32.37l0 0c-7.47,-4.08 -16.86,-1.32 -20.94,6.15 -4.08,7.47 -1.33,16.86 6.14,20.94 7.47,4.08 16.87,1.33 20.95,-6.14 4.08,-7.47 1.32,-16.86 -6.15,-20.95z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M405.19 174.73c-2.62,4.8 -8.62,6.56 -13.42,3.94 -4.79,-2.62 -6.56,-8.63 -3.94,-13.42 2.62,-4.8 8.63,-6.56 13.42,-3.94 4.8,2.62 6.56,8.63 3.94,13.42z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "fil8",
    points: "396.63,170.98 396.4,168.99 433.85,164.71 434.07,166.7 "
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "fil4 str0",
    cx: 292.89,
    cy: 200.52,
    r: 21.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M283.67 215.83l-1.75 -0.02c-1.24,-0.01 -2.24,-1.02 -2.22,-2.26l0.04 -6.3c0.01,-1.24 1.03,-2.24 2.27,-2.23l1.75 0.01c1.23,0.02 2.23,1.03 2.22,2.27l-0.05 6.3c-0.01,1.24 -1.02,2.23 -2.26,2.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil10",
    d: "M293.92 215.91l-1.92 -0.02c-1.19,-0.01 -2.15,-0.98 -2.14,-2.18l0.09 -12.26c0.01,-1.19 0.99,-2.15 2.18,-2.14l1.92 0.01c1.19,0.01 2.15,0.98 2.14,2.18l-0.09 12.26c-0.01,1.2 -0.99,2.16 -2.18,2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil11",
    d: "M305.4 216l-2.94 -0.03c-1.36,-0.01 -2.45,-1.12 -2.44,-2.48l0.14 -17.66c0.01,-1.36 1.12,-2.45 2.48,-2.44l2.94 0.02c1.36,0.01 2.45,1.12 2.44,2.48l-0.14 17.67c-0.01,1.35 -1.12,2.45 -2.48,2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil12",
    d: "M307.78 179.75l-5.97 2.48 2.23 1.67 -7.02 9.21 -3.7 -4.37c-0.14,-0.17 -0.34,-0.26 -0.55,-0.24 -0.22,0.01 -0.41,0.11 -0.54,0.29l-5.08 7.32 -2.79 -2.62c-0.14,-0.14 -0.34,-0.2 -0.54,-0.18 -0.2,0.02 -0.38,0.13 -0.49,0.29l-4.47 6.44c-0.21,0.31 -0.14,0.74 0.17,0.95 0.32,0.22 0.74,0.14 0.96,-0.17l4.01 -5.78 2.79 2.61c0.15,0.14 0.35,0.21 0.55,0.18 0.2,-0.02 0.38,-0.12 0.49,-0.29l5.02 -7.23 3.68 4.33c0.13,0.16 0.33,0.25 0.54,0.25 0.09,-0.01 0.19,-0.03 0.27,-0.07 0.1,-0.04 0.19,-0.11 0.26,-0.2l7.54 -9.9 1.84 1.39 0.57 -4.55 0.02 -0.02c0.16,-0.21 0.18,-0.49 0.07,-0.71l0.14 -1.08z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "fil13 str1",
    points: "358.84,95.78 372.02,108.96 398.86,82.13 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 198.67,
    y: 121.25,
    width: 114.21,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 198.67,
    y: 135.16,
    width: 114.21,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 198.67,
    y: 149.06,
    width: 114.21,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 198.67,
    y: 162.97,
    width: 58.51,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil3",
    x: 198.67,
    y: 176.88,
    width: 58.51,
    height: 2.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil14 str2",
    cx: 150.57,
    cy: 86.01,
    r: 22.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil15",
    transform: "matrix(-0.213575 -0.213575 -0.213575 0.213575 138.612 101.909)",
    width: 24.42,
    height: 131.23,
    rx: 12.21,
    ry: 12.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil0",
    cx: 219.78,
    cy: 95.56,
    r: 3.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil16",
    cx: 208.67,
    cy: 95.56,
    r: 3.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil17",
    cx: 198.1,
    cy: 95.56,
    r: 3.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil18",
    d: "M354.39 248.35c-0.95,3.38 -3.08,5.76 -5.53,5.76l-182.7 0c-2.46,0 -4.58,-2.38 -5.53,-5.76l193.76 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCaseManager);
export default __webpack_public_path__ + "static/media/use-case-manager.4fac064090416296f8e1452b0a6dcc44.svg";
export { ForwardRef as ReactComponent };